// How long the kiosk sits with nobody touching it (and no video playing) before going back to the home page
const KIOSK_IDLE_TIMEOUT_MS = 180 * 1000;

let kioskIdleTimer = null;
let kioskAwaitingVisitor = false;

$(document).ready(function () {
    if ($('.tablet-kiosk').length) {
        initKioskIdleTimeout();
        magicDownload();
    }
});

$(document).on('click', '[data-page-to-open]', function (e) {
    e.preventDefault();

    let pageUrl = $(this).data('page-to-open');
    let $target = showKioskPage(pageUrl);

    if ($target.length) {
        analyticsPageView(pageUrl, $target.data('title'));
    }

    kioskIdleStart();
});

function showKioskPage(pageUrl) {
    let $currentSection = $('.page-section.active');
    let pageId = pageUrl === '/' ? 'page-home' : 'page-' + pageUrl.replace(/\//g, '');

    // Stop and unload the gallery videos on the page being left, so a returning visitor finds them back at the
    // start and Android isn't left holding a decoder for each one (see resetVideo). The homepage's own looping
    // background video is deliberately left out of this: it's ambient, not something a visitor was watching,
    // and it keeps its progress.
    $currentSection.find('.main-video-container video').each(function () {
        resetVideo(this);
    });

    $currentSection.find('.video-container').removeClass('playing');

    // Remove active from current
    $currentSection.removeClass('active');

    // Add active to target
    let $target = $('#' + pageId).addClass('active');

    // Resume the homepage video if the browser paused it while its section was hidden - no need to seek or
    // reload it, it's still the same continuous loop
    if (pageId === 'page-home') {
        $('#page-home video').each(function () {
            if (this.paused) {
                this.play();
            }
        });
    }

    return $target;
}

// Idle timeout: once nobody has touched the kiosk for KIOSK_IDLE_TIMEOUT_MS it goes back to the home page and
// the visitor's analytics session ends. The countdown restarts on every tap and whenever a video stops or
// finishes, and doesn't run while a video is playing so a long video is never cut short.
function initKioskIdleTimeout() {
    // One device, a stream of different visitors: give each visitor their own analytics session
    analyticsCustomSessions = true;

    document.addEventListener('pointerdown', function () {
        if (kioskAwaitingVisitor) {
            // First touch after a reset, so the new visitor's session starts with the home page they were looking at
            kioskAwaitingVisitor = false;
            analyticsPageView('/', $('#page-home').data('title'));
        }

        if (!kioskVideoPlaying()) {
            kioskIdleStart();
        }
    }, {capture: true, passive: true});

    // Media events don't bubble, so listen in the capture phase to catch videos added by magicDownload
    ['pause', 'ended'].forEach(function (eventName) {
        document.addEventListener(eventName, function (e) {
            if (isGalleryVideo(e.target)) {
                kioskIdleStart();
            }
        }, true);
    });

    document.addEventListener('play', function (e) {
        if (isGalleryVideo(e.target)) {
            kioskIdleStop();
        }
    }, true);
}

function isGalleryVideo(el) {
    return el.matches && el.matches('.main-video-container video');
}

function kioskVideoPlaying() {
    return $('.main-video-container video').filter(function () {
        return !this.paused && !this.ended;
    }).length > 0;
}

function kioskIdleStart() {
    clearTimeout(kioskIdleTimer);
    kioskIdleTimer = setTimeout(kioskIdleTimeout, KIOSK_IDLE_TIMEOUT_MS);
}

function kioskIdleStop() {
    clearTimeout(kioskIdleTimer);
    kioskIdleTimer = null;
}

function kioskIdleTimeout() {
    kioskIdleTimer = null;

    // Already at home? Leave it alone so the home video doesn't restart
    if (!$('#page-home').hasClass('active')) {
        showKioskPage('/');
    }

    analyticsEndSession();
    kioskAwaitingVisitor = true;
}

// Every video is downloaded into memory by preloadVideos(), so letting the browser also preload the gallery
// videos itself (preload="auto") would download each one twice and have them all decoding at once. They're
// loaded when a visitor asks for them instead. Videos that autoplay (the homepage's) are left alone.
function deferGalleryVideoLoading(html) {
    return (html || '').replace(/<video\b[^>]*>/g, function (tag) {
        return /\bautoplay\b/.test(tag) ? tag : tag.replace(/\bpreload="auto"/, 'preload="none"');
    });
}

function magicDownload() {
    // let $progressBar = $('#progress-bar');
    let $loadingStatus = $('#loading-status');
    // let $loadingOverlay = $('#loading-overlay');

    $loadingStatus.text('Downloading pages...');

    $.ajax({
        url: '/Magic/MagicDownload',
        method: 'GET',
        success: async function (response) {
            let isFirst = true;

            $.each(response, function (index, page) {
                // Parse the full HTML
                let $pageHTML = $(deferGalleryVideoLoading(page.html));

                let pageId = page.url === '/' ? 'page-home' : 'page-' + page.url.replace(/\//g, '');

                // Create a section for each page
                let $section = $('<section>', {
                    'id': pageId,
                    'class': 'page-section' + (isFirst ? ' active' : ''),
                    'data-url': page.url,
                    'data-title': page.title,
                    'html': $pageHTML
                });

                // Add to your container
                $('#sections-container').append($section);

                isFirst = false;
            });

            let $firstPage = $('#sections-container .page-section.active');
            if ($firstPage.length) {
                analyticsPageView($firstPage.data('url'), $firstPage.data('title'));
            }

            $('#sections-container a').each(function () {
                let href = $(this).attr('href');
                if (href) {
                    // Local Copy
                    // href = href.replace('https://kiosk.fecpak.co.nz.elc.php85', '');

                    // Live Copy
                    href = href.replace('https://kiosk.fecpak.com', '');
                    $(this).attr('data-page-to-open', href);
                    $(this).attr('href', '#');
                }
            });

            watchHomeVideo();

            if ($('.glide.video-gallery-glide-container').length) {
                $('.glide.video-gallery-glide-container').each(function () {
                    initVideoCarousel($(this));
                    watchVideoCarousel($(this).parent(), $(this));
                });
            }

            if ($('.main-video-container').length) {
                watchMainVideos();
            }

            $('.home-page-title-container').each(watchHomePageTitle)
            $(window).on('resize', watchHomePageTitle)

            if ($('ul.rotating-list').length) {
                $('ul.rotating-list').each(function () {
                    let $RotatingList = $(this);
                    $RotatingList.wrap('<div class="marquee-container"></div>');
                    let $ListItems = $RotatingList.find('li');

                    $ListItems.each(function () {
                        $RotatingList.append($(this).clone());
                    });
                });
            }

            // Now collect all video URLs from sections
            let videoUrls = [];
            $('#sections-container video source').each(function () {
                let src = $(this).attr('src');
                if (src && !videoUrls.includes(src)) {
                    videoUrls.push(src);
                }
            });

            preloadVideos();

            // navigator.serviceWorker.ready.then(function(registration) {
            //     navigator.serviceWorker.addEventListener('message', function(event) {
            //         if (event.data.type === 'CACHE_PROGRESS') {
            //             let percent = (event.data.loaded / event.data.total) * 100;
            //             let status = event.data.fromCache
            //                 ? `Already cached ${event.data.loaded} of ${event.data.total}...`
            //                 : `Downloading video ${event.data.loaded} of ${event.data.total}...`;
            //             $loadingStatus.text(status);
            //             $progressBar.css('width', percent + '%');
            //         }
            //
            //         if (event.data.type === 'CACHE_COMPLETE') {
            //             $loadingStatus.text('All videos loaded! Ready for offline use.');
            //             setTimeout(() => {
            //                 $loadingOverlay.hide();
            //             }, 1000);
            //         }
            //     });
            //
            //     registration.active.postMessage({
            //         type: 'CACHE_VIDEOS',
            //         urls: videoUrls
            //     });
            // });
        },
        error: function (err) {
            // console.error('Failed to download pages:', err);
            $loadingStatus.text('Failed to download pages. Please refresh.');
        }
    });
}
